/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiChipComponent = {
  defaultProps?: ComponentsProps['MuiChip'];
  styleOverrides?: ComponentsOverrides['MuiChip'];
  variants?: ComponentsVariants['MuiChip'];
};

export const ChipComponent: MuiChipComponent = {
  styleOverrides: {
    root: {
      height: '34px',
      backgroundColor: CIColors.Tertiary,
    },
    label: {
      fontSize: '14px',
      lineHeight: '14px',
      fontWeight: 500,
      letterSpacing: '-0.11px',
      color: '#FFFFFF',
      padding: '0 12px',
    },
    deleteIcon: {
      color: '#FFFFFF',
    },
  },
};
